// extracted by mini-css-extract-plugin
export default {"tabWriteLetter":"TabWriteLetter-module--tabWriteLetter--PmX3R"};